import React, { useEffect } from "react";
import FormLogin from "../../components/FormLogin";

function Login() {
  useEffect(() => {
    document.title = "LifeChain - Login";
  });

  return (
    <div className="Login">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div
            className="col-md-6 col-lg-7 fullscreen-md d-flex justify-content-center align-items-center overlay gradient gradient-54 alpha-7 image-background cover"
            style={{
              backgroundImage:
                "url(https://picsum.photos/1920/1200/?random&gravity=south)",
            }}
          >
            <div className="content">
              <h2 className="display-4 display-md-3 color-1 mt-4 mt-md-0">
                Bienvenido a<span className="bold d-block">LifeChain</span>
              </h2>
              <p className="lead color-1 alpha-5">Inicia sesión en tu cuenta</p>
              <hr className="mt-md-6 w-25" />
            </div>
          </div>
          <div className="col-md-5 col-lg-4 mx-auto">
            <div className="login-form mt-5 mt-md-0">
              <a id="hrefIndex" href="/">
                <img
                  src="images/landing/logo.png"
                  className="logo img-responsive"
                  alt="LifeChain"
                />
              </a>
              <h1 className="color-4 bold">Inicia sesión</h1>
              <p className="color-2 mt-0 mb-4 mb-md-6">
                ¿Aún no tienes cuenta?
                <a href="/signup" className="accent bold ml-2">
                  Crea una aqui
                </a>
              </p>
              <FormLogin />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
